<template>
    <GlobalWindow
      :title="title"
      width="900px"
      :withFooter="false"
      :visible.sync="visible"
      :confirm-working="isWorking"
      @confirm="confirm"
    >
        <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item label="手机号">
                <el-input v-model="form.phone" placeholder="请输入" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="浏览类型">
                <el-select v-model="form.type" placeholder="请选择">
                    <el-option label="浏览房源" value="1"></el-option>
                    <el-option label="咨询房源" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间范围">
                <el-date-picker
                    v-model="form.time"
                    type="datetimerange"
                    @change="changeTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList(1)">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            :data="list"
            border
            v-loading="loading"
            style="width: 100%">
            <el-table-column prop="avatar" label="头像" width="120px" class-name="table-column-avatar" fixed="left">
                <template slot-scope="{row}">
                    <img style="width: 80px; height: 80px;" :src="base + row.avatar">
                </template>
            </el-table-column>
            <el-table-column prop="nickName" label="昵称" min-width="100px" fixed="left"></el-table-column>
            <el-table-column prop="mobile" label="手机号码" min-width="100px"></el-table-column>
            <el-table-column prop="empNo" label="用户状态" min-width="80px">
                <template slot-scope="{row}">
                    <el-tag type="success" v-if="row.isBlock === 0">正常</el-tag>
                    <el-tag type="danger" v-else-if="row.isBlock === 1">拉黑</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <div style="width: 100%; text-align: right; margin-top: 20px;">
            <el-pagination
                @current-change="changePage"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </GlobalWindow>
  </template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import { getHouseViewNum } from '@/api/rentHouse/rhHouse'
export default {
  name: 'userData',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        houseId: null,
        phone: '',
        type: '1',
        time: [],
        startTime: '',
        endTime: ''
      },
      list: [],
      page: 1,
      capacity: 10,
      total: 0,
      loading: false,
      base: process.env.VUE_APP_API_IMG
    }
  },
  methods: {
    open (title, target) {
      this.title = title
      this.form.houseId = target
      this.list = []
      this.form.type = 1
      this.page = 1
      this.visible = true
      this.getList()
    },
    changeTime (e) {
      if (!e) {
        this.form.startTime = ''
        this.form.endTime = ''
      } else {
        this.form.startTime = e[0]
        this.form.endTime = e[0]
      }
    },
    changePage (e) {
      this.page = e
      this.getList()
    },
    getList (page) {
      if (page) {
        this.page = page
      }
      this.loading = true
      getHouseViewNum({
        capacity: this.capacity,
        page: this.page,
        model: this.form
      }).then(res => {
        this.list = res.records
        this.total = res.total
        this.loading = false
      })
    }
  }
}
</script>
